/**
 * `localStorage` への安全なアクセス（`05-database-schema.md` §4.2）。
 *
 * プライベートモードや埋め込み環境ではプロパティアクセス自体が例外を投げることがあるため、
 * 実際に 1 度書いて確かめてから返す。使えない場合は `null` で、呼び出し側（age-gate /
 * progress）がメモリフォールバックを受け持つ。エラーは表示しない。
 */

/** `localStorage` 互換の最小インターフェース。 */
export interface WebStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

/** `localStorage` を安全に取得する。参照・書き込みのどちらが禁じられていても `null`。 */
export function safeStorage(): WebStorage | null {
  try {
    const storage = window.localStorage;
    const probe = 'zp.probe';
    storage.setItem(probe, '1');
    storage.removeItem(probe);
    return storage;
  } catch {
    return null;
  }
}
